import {
  useOutletContext,
  NavLink,
  Outlet,
  useLocation,
} from "react-router-dom";
import "../../../styles/reports.css";
import Header from "../Header";
import utility from "core/Utils";

const Reports = () => {
  const location = useLocation();
  const { token, menuPermissions } = useOutletContext();

  let menus = utility.buildSubMenuFromLocation(location, menuPermissions);
  const { name, client_name } = token;

  return (
    <div id="reports" className="page">
      <Header user={name} client_name={client_name} title="Reports">
        {menus.map(menu => (
          <NavLink
            className={({ isActive }) => (isActive ? "active" : undefined)}
            key={menu.item}
            to={utility.getLastPartOfPath(menu.pathname)}
          >
            {menu.item}
          </NavLink>
        ))}
      </Header>
      <Outlet context={token} />
    </div>
  );
};

export default Reports;
